import React from 'react';
import {Button, Col, Row} from 'reactstrap';

interface IFollowupButtonsProps {
  currentStep: number;
  totalSteps: number;
  canGoBack: boolean;
  onPrevious: () => void;
  isLastStep?: boolean;
  updating?: boolean;
}

const FollowupButtons: React.FC<IFollowupButtonsProps> = ({
                                                            currentStep,
                                                            totalSteps,
                                                            canGoBack,
                                                            onPrevious,
                                                            isLastStep = false,
                                                            updating = false,
                                                          }) => {
  return (
    <div className="followup-step-buttons">
      <Row>
        <Col className="d-flex justify-content-between align-items-center">
          <Button
            color="secondary"
            onClick={onPrevious}
            disabled={!canGoBack}
            style={{visibility: canGoBack ? 'visible' : 'hidden'}}
          >
            Previous
          </Button>

          <div className="d-flex gap-2">
            <Button
              color="primary"
              type="submit"
              disabled={updating}
            >
              {currentStep === totalSteps || isLastStep ? 'DONE' : 'CONTINUE'}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FollowupButtons;
